import {
    useContext,
    type FC
} from "react";
import {
    ScrollView,
    View
} from "react-native";
import type IChartContentProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    ChartContext
} from "../../context";
import ChartState from "../state";
import ChartTable from "../table";
import Card from "../../../card";

const ChartContent: FC<IChartContentProps> = ({
    stateActionTitle,
    stateDescription,
    customLocalize,
    onStateAction,
    legendBottom,
    customTheme,
    stateTitle,
    legendTop,
    children,
    value
}) => {
    const context = useContext(ChartContext);

    const {
        shapeConfigs
    } = NCoreUIKitTheme.useContext(customTheme);

    const dataState = context?.dataState ?? "ready";

    const renderOverlay = () => {
        if(dataState !== "ready") {
            return <ChartState
                customLocalize={customLocalize}
                actionTitle={stateActionTitle}
                description={stateDescription}
                customTheme={customTheme}
                onAction={onStateAction}
                title={stateTitle}
                kind={dataState}
            />;
        }

        if(context?.isTableVisible) {
            return <ScrollView
                contentContainerStyle={stylesheet.tableContent}
                style={stylesheet.table}
            >
                <ChartTable
                    customLocalize={customLocalize}
                    customTheme={customTheme}
                />
            </ScrollView>;
        }

        return null;
    };

    const overlay = renderOverlay();

    const {
        plot: plotDynamicStyle
    } = useStyles({
        plotHeight: context?.plotHeight,
        isOverlaid: !!overlay,
        shapeConfigs
    });

    return <Card.Content
        customTheme={customTheme}
    >
        {value}
        {legendTop}
        <View
            style={[
                stylesheet.plot,
                plotDynamicStyle
            ]}
        >
            <View
                style={[
                    stylesheet.body,
                    overlay ? stylesheet.hidden : undefined
                ]}
                aria-hidden={overlay ? true : undefined}
                aria-busy={context?.isLoading}
            >
                {children}
            </View>
            {
                overlay ?
                    <View
                        style={stylesheet.overlay}
                    >
                        {overlay}
                    </View>
                :
                    null
            }
        </View>
        {legendBottom}
    </Card.Content>;
};
export default Object.assign(ChartContent, {
    cardPart: "content" as const
});
